import {
  IconButton,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import SocialRating from "./SocialRating";

const SocialPeopleListItemPeopleShort = ({ object: social }) => {
  return (
    <Link
      to={`/people/${social.people_1.id}`}
      target="_blank"
      style={{
        textDecoration: "none",
        color: "inherit",
      }}
    >
      <ListItem
        secondaryAction={
          <Tooltip title={Math.round(social.weight * 100) / 100}>
            <IconButton disableFocusRipple disableRipple sx={{ p: 0 }}>
              <SocialRating value={social.weight} />
            </IconButton>
          </Tooltip>
        }
      >
        <ListItemButton>
          <ListItemText
            primary={social.people_1.best_name}
            primaryTypographyProps={{
              noWrap: true,
              variant: "body2",
            }}
          />
          <ListItemText
            primary={social.people_1.best_email_address}
            primaryTypographyProps={{
              noWrap: true,
              variant: "caption",
              width: "100%",
              textAlign: "end",
            }}
          />
        </ListItemButton>
      </ListItem>
    </Link>
  );
};

export default SocialPeopleListItemPeopleShort;
